import { Action } from '@ngrx/store';
import { DocumentDto } from '@app/generated/model';

export enum DocumentActionTypes {
  LoadDocuments = 'LoadDocuments',
  LoadDocumentsSuccess = 'LoadDocumentsSuccess',
  LoadDocumentPage = 'LoadDocumentPage',
  LoadDocumentPages = 'LoadDocumentPages',
  LoadOpenedTabs = 'LoadOpenedTabs',
  LoadActiveTab = 'LoadActiveTab',
}

export class LoadDocuments implements Action {
  readonly type = DocumentActionTypes.LoadDocuments;
  constructor(public workOrderId: string) {}
}

export class LoadDocumentsSuccess implements Action {
  readonly type = DocumentActionTypes.LoadDocumentsSuccess;
  constructor(public documents: DocumentDto[]) {}
}

export class LoadDocumentPage implements Action {
  readonly type = DocumentActionTypes.LoadDocumentPage;
  constructor(
    public docId: string,
    public page: number,
    public username: string,
  ) {}
}

export class LoadDocumentPages implements Action {
  readonly type = DocumentActionTypes.LoadDocumentPages;
  constructor(
    public pages: { [docId: string]: number },
    public username: string,
  ) {}
}

export class LoadOpenedTabs implements Action {
  readonly type = DocumentActionTypes.LoadOpenedTabs;
  constructor(
    public openedTabIds: string[],
    public username: string,
  ) {}
}

export class LoadActiveTab implements Action {
  readonly type = DocumentActionTypes.LoadActiveTab;
  constructor(
    public activeTabId: string,
    public username: string,
  ) {}
}

export type DocumentActions =
  | LoadDocuments
  | LoadDocumentsSuccess
  | LoadDocumentPage
  | LoadDocumentPages
  | LoadOpenedTabs
  | LoadActiveTab;
